const CookieConsent = require("./CookieConsent");
const { ready } = require("./utils/dom");

ready(function () {
  if (window.madCC && window.madCC.config) {
    const cookieConsent = new CookieConsent(window.madCC.config);

    // Attach the instance to the global namespace for external access/debugging.
    window.madCC.instance = cookieConsent;

    // Named entry point for themes and inline handlers.
    window.madCC.openSettings = function () {
      cookieConsent.modal.show();
    };
  }
});
